import * as React from 'react';
import { Fragment, ReactNode } from 'react';
import { PaginationContext, PaginationContextType } from './PaginationContext';
import { PaginationKeyInterface } from './PaginationKeyInterface';

/**
 * Class that will render the current page of items
 */
export class PaginationList<T extends PaginationKeyInterface> extends React.Component {
    public static contextType = PaginationContextType;
    public context!: PaginationContext<T>;

    public render() {
        const itemsOnPage = this.context.itemsOnPage;
        console.debug(`[PaginationList] Render with ${itemsOnPage.length} items on page`, itemsOnPage);
        if (itemsOnPage.length === 0) {
            // Nothing to display
            return null;
        }

        const children = this.props.children;

        return <>{itemsOnPage.map(i => this.renderItem(i, children))}</>;
    }

    private renderItem(item: T, children: ReactNode) {
        if (typeof children === 'function') {
            return <Fragment key={item.getPaginationItemKey()}>{children(item)}</Fragment>;
        } else {
            throw new TypeError('Can not handle children of type ' + typeof children);
        }
    }
}
